import { useState, useEffect, useCallback } from 'react';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { getUnreadMessageCount } from '../api/api';

const POLL_INTERVAL_MS = 20000;

// Polls the unread message count so the header badge stays current app-wide.
const useUnreadMessageCount = (enabled = true) => {
  const { getToken, isAuthenticated } = useKindeAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled || !isAuthenticated) return;
    try {
      const token = await getToken();
      const value = await getUnreadMessageCount(token);
      setCount(value || 0);
    } catch (err) {
      // ignore transient errors
    }
  }, [enabled, isAuthenticated, getToken]);

  useEffect(() => {
    if (!enabled || !isAuthenticated) return undefined;
    refresh();
    const interval = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [enabled, isAuthenticated, refresh]);

  return { count, refresh };
};

export default useUnreadMessageCount;
